import Swiper from 'swiper';
import { Navigation, Pagination, Scrollbar } from 'swiper/modules';
import LazyLoad from 'vanilla-lazyload';

const lazyInstance = new LazyLoad();

class SwiperSlider extends HTMLElement {
    constructor() {
        super();
        this.swiper = this.querySelector('.swiper');
        this.expandedSlider = this.querySelector('.expanding-slider');
        this.swiperInstance = null;

        const raw = this.getAttribute('data-swiper-options') || '{}';
        const userOptions = JSON.parse(raw);

        const nextButton = this.querySelector('.swiper-button-next');
        const prevButton = this.querySelector('.swiper-button-prev');
        const scrollbar = this.querySelector('.swiper-scrollbar');

      
        this.swiperOptions = {
            modules: [Navigation, Pagination, Scrollbar],
            ...userOptions,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: nextButton,
                prevEl: prevButton,
            },
            observeChildren: true,
            observer: true,
            resize: true,
        };

        if (scrollbar) {
            this.swiperOptions.scrollbar = {
                el: scrollbar,
            };
        }


            this.initSwiper();
    }

    initSwiper() {
       this.swiperInstance = new Swiper(this.swiper, this.swiperOptions);

       if (this.expandedSlider) {
        this.setupExpandedSlider();
       }
    }

    connectedCallback() {

        if (this.querySelector('[data-blog-tab-trigger-container-scrollable]')) {
            this.querySelectorAll('[data-blog-tab-trigger]').forEach(tabTrigger => {
                tabTrigger.addEventListener('click', (e) => {

                    const tagHandle = e.target.dataset.tagHandle;

                    this.fetchBlog('fitness-bodybuilding', tagHandle);

                    this.querySelectorAll('[data-blog-tab-trigger]').forEach(el => {
                        el.classList.remove('active');
                    });

                    tabTrigger.classList.add('active');
                });
            });
        }

        if (!this.querySelector('[data-tab-trigger-container]')) {
            return;
        }

        const tabTriggerContainer = this.querySelector('[data-tab-trigger-container]');

        this.querySelectorAll('[data-tab-trigger]').forEach(tabTrigger => {
            tabTrigger.addEventListener('click', (e) => {
                const collectionHandle = e.currentTarget.dataset.collectionHandle;

                this.fetchCollection(collectionHandle);

                this.querySelectorAll('[data-tab-trigger]').forEach(el => {
                    el.classList.remove('active');
                });

            
                tabTrigger.classList.add('active');
            });
        });

        const container = this.querySelector('[data-tab-trigger-container-scrollable]');
        const scrollButtonNext = this.querySelector('[data-tab-scroll-button-next]');
        const scrollButtonPrev = this.querySelector('[data-tab-scroll-button-prev]');
        const scroll_amount = 100;

        if (!container || !scrollButtonNext || !scrollButtonPrev) {
            return;
        }

        // Optional: show/hide button based on overflow
        function checkOverflow() {
            const scrollLeft = container.scrollLeft;
            const maxScrollLeft = container.scrollWidth - container.clientWidth;

            // Show or hide prev/next buttons based on scroll position
            scrollButtonPrev.style.display = scrollLeft > 0 ? 'flex' : 'none';
            scrollButtonNext.style.display = scrollLeft < maxScrollLeft ? 'flex' : 'none';
        }

        scrollButtonNext.addEventListener('click', (e) => {
            e.preventDefault();
            container.scrollBy({
                left: scroll_amount,
                behavior: 'smooth',
            });
        });

        scrollButtonPrev.addEventListener('click', (e) => {
            e.preventDefault();
            container.scrollBy({
                left: -scroll_amount,
                behavior: 'smooth',
            });
        });

        container.addEventListener('scroll', checkOverflow, {
            passive: true,
        });

        // swiper-slider-expanding.liquid & reviews-slider.liquid
        function imgClick() {
            const cardUrl = document.querySelectorAll('.card-url');
            const images = document.querySelectorAll('.card-image');
            images.forEach(image => {
                const link = image.closest('.swiper-slide').querySelector('.card-url');
                if (link) {
                    image.addEventListener('click', (event) => {
                        event.preventDefault();
                        window.location.href = link.getAttribute('href');
                    });
                    image.addEventListener('keydown', (event) => {
                        if (event.key === 'Enter') {
                            window.location.href = link.getAttribute('href');
                        }
                    });
                }
            });
        }

        // Run on load and resize
        checkOverflow();
        imgClick();

        window.addEventListener('resize', checkOverflow, {
            passive: true,
        });

        
    }

    setupExpandedSlider() {
        const slides = this.expandedSlider.querySelectorAll('.swiper-slide');

        slides.forEach(slide => {
            slide.addEventListener('click', (e) => {

                if (slide.classList.contains('swiper-slide-active')) {
                    return;
                }
               
                if (slide.classList.contains('swiper-slide-next')) {
                    e.preventDefault();
                    e.stopPropagation();

                    this.swiperInstance.slideNext();
                }

                if (slide.classList.contains('swiper-slide-prev')) {
                    e.preventDefault();
                    e.stopPropagation();

                    this.swiperInstance.slidePrev();
                }

            });
        });
    }


    async fetchCollection(collectionHandle) {
        const sectionUrl = `/collections/${collectionHandle}?view=collection-tab-slider&limit=24`;

        try {
            const res = await fetch(sectionUrl);
            const html = await res.text();
            const wrapper = this.querySelector('[data-swiper-wrapper]');
            wrapper.innerHTML = html;

            this.swiper.swiper.slideTo(0, false);
        } catch (err) {
            console.error('Failed to fetch collection section:', err);
        }
    }

    async fetchBlog(blogHandle, tagHandle) {
        let sectionUrl = '';

        if (tagHandle === 'all') {
            sectionUrl = `/blogs/${blogHandle}?view=filtered-article-slider`;
        } else {
            sectionUrl = `/blogs/${blogHandle}/tagged/${tagHandle}?view=filtered-article-slider`;
        }

        try {
            const res = await fetch(sectionUrl);
            const html = await res.text();
            const wrapper = this.querySelector('[data-swiper-wrapper]');
            wrapper.innerHTML = html;

            this.swiper.swiper.update();
            this.swiper.swiper.slideTo(0, false);
        } catch (err) {
            console.error('Failed to fetch blog section:', err);
        }
    }

    
}

customElements.define('swiper-slider', SwiperSlider);